import styled from "styled-components";
import RichText from "../rich-text";

const P = styled.p`
  margin-top: 0;
  margin-bottom: 1rem;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const Paragraph = ({ content }) => (
  <P>
    <RichText content={content} />
  </P>
);

export default Paragraph;
